document.addEventListener("DOMContentLoaded", function() {
  const iconButton = document.querySelector(".header__icon-menu");
  const menu = document.querySelector(".mobile-menu");
  const closeButtonMenu = document.querySelector(".mobile-menu__icon-menu-close");
  const searchButton = document.querySelector(".header__search-button");
  const searchComponent = document.querySelector(".search__component");
  const closeButtonSearch = document.querySelector(".search__button-close");
  const drawerToggleButton = document.querySelector(".collection-bar__filters");
  const drawerContent = document.querySelector(".drawer-content");
  const drawerCloseButton = document.querySelector(".filters-drawer__close-button");

  function toggleMenu() {
    if (searchComponent && searchComponent.classList.contains("_active")) {
      deactivateSearch();
    }
    if (drawerContent && drawerContent.classList.contains("_active")) {
      deactivateDrawer();
    }
    if (menu) menu.classList.toggle("_active");
    if (iconButton) iconButton.classList.toggle("_active");
  }

  function activateSearch() {
    if (menu && menu.classList.contains("_active")) {
      toggleMenu();
    }
    if (drawerContent && drawerContent.classList.contains("_active")) {
      deactivateDrawer();
    }
    if (searchComponent) searchComponent.classList.add("_active");
  }

  function deactivateSearch() {
    if (searchComponent) searchComponent.classList.remove("_active");
  }

  function toggleDrawer() {
    if (menu && menu.classList.contains("_active")) {
      toggleMenu();
    }
    if (searchComponent && searchComponent.classList.contains("_active")) {
      deactivateSearch();
    }
    if (drawerContent) drawerContent.classList.toggle("_active");
  }

  function deactivateDrawer() {
    if (drawerContent) drawerContent.classList.remove("_active");
  }

  if (iconButton) {
    iconButton.addEventListener("click", function(event) {
      toggleMenu();
      event.stopPropagation();
    });
  }

  if (closeButtonMenu) {
    closeButtonMenu.addEventListener("click", function(event) {
      menu.classList.remove("_active");
      iconButton.classList.remove("_active");
      event.stopPropagation();
    });
  }

  document.addEventListener("click", function(event) {
    if (menu && !menu.contains(event.target) && menu.classList.contains("_active")) {
      menu.classList.remove("_active");
      iconButton.classList.remove("_active");
    }
    if (drawerContent && !drawerContent.contains(event.target) && drawerContent.classList.contains("_active")) {
      deactivateDrawer();
    }
    if (searchComponent && !searchComponent.contains(event.target) && searchComponent.classList.contains("_active")) {
      deactivateSearch();
    }
  });

  if (searchButton) {
    searchButton.addEventListener("click", function(event) {
      activateSearch();
      event.stopPropagation();
    });
  }

  if (closeButtonSearch) {
    closeButtonSearch.addEventListener("click", function(event) {
      deactivateSearch();
      event.stopPropagation();
    });
  }

  if (drawerToggleButton) {
    drawerToggleButton.addEventListener("click", function(event) {
      toggleDrawer();
      event.stopPropagation();
    });
  }

  if (drawerCloseButton) {
    drawerCloseButton.addEventListener("click", function(event) {
      deactivateDrawer();
      event.stopPropagation();
    });
  }

  // Add event listener to filter checkboxes to stop event propagation
  const filterCheckboxes = document.querySelectorAll(".filter-group__checkbox");
  filterCheckboxes.forEach(function(checkbox) {
    checkbox.addEventListener("click", function(event) {
      event.stopPropagation();
    });
  });
});